import { localized } from '@/i18n/localize'
export const checkoutStrings = localized({
  preparing: 'Setting up the payment…',
  confirming: 'Checking your payment. This usually takes a minute.',
  dontClose: 'Keep this open until it finishes.',
  countdown: (mmss: string) => `Checking again in ${mmss}`,
  successTitle: 'Payment successful',
  failedTitle: 'Payment Failed',
  failedDescription: 'Your payment was cancelled or failed. You can try again.',
  cancelledTitle: 'Payment cancelled',
  unconfirmedTitle: "We couldn't confirm your payment yet",
  processingTitle: 'Payment Submitted',
  processingDescription: 'Your payment is being processed. Check your transactions for the latest status.',
  tryAgain: 'Try again',
  done: 'Done',
  close: 'Close',
  secureNote: 'All transactions are secure and encrypted',
  rentDescription: 'Rent payment',
  rentSuccessTitleTenant: 'Payment sent',
  rentSuccessSent: 'Your landlord has been notified.',
  rentSuccessPendingLandlord: 'Your landlord will confirm it shortly.',
  leaseFeeTitle: 'Lease Management Fee',
  leasePayAndActivate: 'Pay & Activate Lease',
  leaseActivating: 'Activating your lease',
  leaseActivatingDescription: "This usually takes a few seconds. Please don't close this page.",
  leasePaymentFailed: 'Payment was cancelled or could not be confirmed',
  leasePaymentUnconfirmed: "We couldn't confirm your payment yet. If money was deducted, the lease will activate shortly — please check again in a moment.",
  leaseFeeActivationNote: 'The lease starts the moment this is paid, and the tenant is notified.',
  agreementPayNow: 'Pay Now',
  agreementDescription: 'Rental agreement',
  agreementWaiting: 'Checking your payment. This usually takes a minute.',
  agreementInProgress: 'Payment in Progress',
  agreementPendingDesc: 'Your payment is being processed. This usually takes a few minutes. Please check back shortly.',
  checkoutTitle: 'Confirm your plan',
  confirmUpgrade: 'Confirm Upgrade',
  activatingSubscription: 'Activating your subscription',
  activatingSubscriptionDescription: 'This can take a minute. Your plan updates as soon as it is done.',
  checkoutFailed: 'Payment was cancelled or could not be completed',
  checkoutStatusNotActive: 'The plan did not activate. If money was deducted it will be refunded.',
  checkoutUnexpected: 'Something went wrong while starting the payment.',
})

export const feeStrings = localized({
  title: 'Payment summary',
  rent: 'Rent',
  gatewayFee: (pct?: number) => (pct ? `Gateway fee (${pct}%)` : 'Gateway fee'),
  gst: 'GST on fees',
  platformFee: 'Platform fee',
  total: 'You pay',
  landlordReceives: 'Landlord receives',
})
